module.exports = __webpack_public_path__ + "img/line1.d24dae51.svg";